import { useSnackbar } from 'notistack'
import React, { memo, useCallback } from 'react'
import { connect } from 'react-redux'

import { finalizarLlenado } from '../../../../../../../../models/movimiento/movimientoService'
import { closeDialog } from '../../../../../../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'
import { actualizarEstadoSilos } from '../../../../../../actions'
import { OperacionFinDeLlenadoView } from '../components/OperacionFinDeLlenadoView'

export const OperacionFinDeLlenado = connect(null, { closeDialog, actualizarEstadoSilos })(
  memo(({ silo, closeDialog, actualizarEstadoSilos }) => {
    const { enqueueSnackbar } = useSnackbar()
    return (
      <OperacionFinDeLlenadoView
        silo={silo}
        aceptar={async () => {
          try {
            await finalizarLlenado(silo)
            closeDialog()
            enqueueSnackbar('Fin de llenado correcto')
            actualizarEstadoSilos()
          } catch (error) {
            enqueueSnackbar('Fin de llenado incorrencto', { variant: 'error' })
          }
        }}
        cancelar={useCallback(() => {
          closeDialog('FIN_LLENADO_SILO')
        }, [closeDialog])}
      />
    )
  })
)
